export const APP_OPTIONS = [
  {label: 'Blog', value: 'blog'},
  {label: 'SEO', value: 'seo'},
  {label: 'APC', value: 'apc'},
  {label: 'AEO', value: 'aeo'},
  {label: 'App plaza', value: 'plaza'},
];

export const TYPE_OPTIONS = [
  {label: 'Feature', value: 'feature'},
  {label: 'Improvement', value: 'improvement'},
  {label: 'Removed', value: 'removed'},
];

export const CHOICE_OPTIONS = [
  {label: 'Published', value: 'published'},
  {label: 'Draft', value: 'draft'},
];

export const sortOptions = [
  {label: 'Created (newest)', value: 'createdAt:desc'},
  {label: 'Created (oldest)', value: 'createdAt:asc'},
  {label: 'Title (A-Z)', value: 'title:asc'},
  {label: 'Title (Z-A)', value: 'title:desc'},
  {label: 'Impression (increase)', value: 'impressions:asc'},
  {label: 'Impression (decrease)', value: 'impressions:desc'},
  {label: 'Click (increase)', value: 'clicks:asc'},
  {label: 'Click (decrease)', value: 'clicks:desc'},
];

export const filterOptions = [
  {label: 'Published', value: 'published'},
  {label: 'Draft', value: 'draft'},
];

export const ITEM_PER_PAGE = [
  {label: '10', value: '10'},
  {label: '20', value: '20'},
  {label: '50', value: '50'},
];
